export enum CaseAddressFillOptions {
  AUTO_COMPLETE_ADDRESS = 'Auto-complete address',
  FILL_WITH_CLIENT_ADDRESS = 'Fill with client address',
  LEAVE_BLANK = 'Leave blank'
}
